import cn from 'classnames';
// Styles
import styles from './MerchSizeOptions.module.scss';
import Button from 'ui3/Button/Button';

export type MerchSizeOption = {
  value: string;
  isSelected: boolean;
};

type MerchSizeOptionsProps = {
  availableSizeOptions: MerchSizeOption[];
  totalSizeOptions: MerchSizeOption[];
  handleSelectOption: (option: string) => void;
};

const MerchSizeOptions = ({
  availableSizeOptions,
  totalSizeOptions,
  handleSelectOption,
}: MerchSizeOptionsProps) => {
  const onButtonClick = ({ value, isSelected }: MerchSizeOption) => {
    if (!isSelected) {
      handleSelectOption(value);
    }
  };

  return (
    <div className={styles.optionsContainer}>
      {totalSizeOptions.map(({ value, isSelected }, index) => {
        const isAvailable = availableSizeOptions.some(
          (item) => item.value === value
        );
        return (
          <Button
            key={index}
            variant="secondary"
            className={cn(styles.option, {
              [styles.selected]: isSelected,
            })}
            onClick={() => {
              onButtonClick({ value, isSelected });
            }}
            disabled={!isAvailable}
            size="small"
          >
            {value}
          </Button>
        );
      })}
    </div>
  );
};

export default MerchSizeOptions;
